<div class="well" [class.border--all]="border()">
  <ng-content />
</div>
